module.exports = __webpack_public_path__ + "img/php.bfb8bd89.svg";